<template>
  <div class="desk-controls-wrap" :class="{ darken : deskCtrlsOnWhite }">
    <div class="desk-controls d-flex align-items-center" :class="{ fixed: fixed }" ref="deskCtrls">
      <social :shareToggle="true"></social>
      <div class="toggles">
        <div class="report-type" :class="[ industry === 'mktg' ? '' : 'right' ]" ref="typeToggle" @click="toggle">
          <p>Marketer</p>
          <div class="button"></div>
          <p>IT</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { gnavHeightTablet } from '@/lib/consts'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import Social from '@/components/report/content/Social'
  import 'Waypoint'

  export default {
    name: 'SideNavigation',
    data () {
      return {
        wp: null,
        fixed: false
      }
    },
    components: { Social },
    mixins: [ StateMixin ],
    methods: {
      toggle () {
        this.$store.dispatch( 'setIndustry', this.industry === 'mktg' ? 'it' : 'mktg' )
      }
    },
    mounted () {
      this.$store.dispatch( 'setDeskCtrlsHeight', this.$refs.deskCtrls.offsetHeight )
      this.wp = new window.Waypoint( {
        element: this.$el,
        handler: dir => {
          this.fixed = dir === 'down'
        },
        offset: -gnavHeightTablet
      } )
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/global/the_goods";

  .desk-controls {
    position   : absolute;
    top        : $gnavHeightTablet;
    right      : 0;
    z-index    : 101;
    height     : 32px;
    margin     : 21px 19px 0 0;
    opacity    : 0;
    transition : opacity 1s;

    body.show-gnav & {
      transition-delay : 0.5s;
      opacity          : 1;
    }

    &.fixed {
      top      : 0;
      position : fixed;
    }

    .toggles, .sharetoggle, .icon-wrap {
      height : 100%;
    }

    .toggles {
      border-radius : 16px;
      padding       : 0 14px;
      border        : solid 1px #eee;
      position      : relative;
      z-index       : 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/DeskControls.vue